import _Stepper from './Stepper';
import './style';

export * from './type';
export type { StepperProps } from './Stepper';

export const Stepper = _Stepper;
export default Stepper;
